import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { id: "dropin-container" }, null, -1)
const _hoisted_2 = { class: "flex justify-center mx-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ps_button = _resolveComponent("ps-button")!
  const _component_ps_modal = _resolveComponent("ps-modal")!
  const _component_ps_loading_dialog = _resolveComponent("ps-loading-dialog")!
  const _component_ps_error_dialog = _resolveComponent("ps-error-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ps_modal, {
      ref: "psmodal",
      line: "hidden",
      isClickOut: false
    }, {
      body: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_ps_button, { id: "submit-button" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('paypal_credit_card_modal__submit_payment')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_ps_button, {
            theme: "btn-second",
            class: "text-center mx-4",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.psmodal.toggle(false)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('paypal_credit_card_modal__close')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_ps_loading_dialog, {
      ref: "psloading",
      isClickOut: false
    }, null, 512),
    _createVNode(_component_ps_error_dialog, { ref: "ps_error_dialog" }, null, 512)
  ], 64))
}